import * as THREE from 'three';
import simpleVert from './simple-vert.js'
import copyFrag from './copy-frag.js'
function useTextureToTarget(texture, toTarget=null){
	const copyCamera = useRef()
	const copyGeometry = useRef()
	const copyScene = useRef()
	const copyMaterial = useRef()
	const { gl } = useThree()
	useEffect(() => {
		copyCamera.current = new THREE.OrthographicCamera(-0.5, 0.5, 0.5, -0.5, 0, 1000);
		copyGeometry.current = new THREE.PlaneGeometry( 1, 1 );
		copyScene.current = new THREE.Scene();
		copyMaterial.current = new THREE.ShaderMaterial({
			defines: {
				USE_VUV: ''
			},
			vertexShader: simpleVert,
			fragmentShader: copyFrag,
			uniforms:{
				tDiffuse: {value: null}
			}
		});
		copyScene.current.add(new THREE.Mesh(copyGeometry.current, copyMaterial.current));
		return () => {
			copyGeometry.current.dispose()
			copyMaterial.current.dispose()
		}
	}, [])
	useFrame(() => {
		copyMaterial.current.uniforms.tDiffuse.value = texture;
		gl.setRenderTarget(toTarget);
		gl.render(copyScene.current, copyCamera.current);
	})
}
class RenderBuffer{
	constructor(opt={isFloat:false}){
		if(opt.isFloat){
			this._target = new THREE.WebGLRenderTarget(1,1,{type: THREE.FloatType});
			this.target = new THREE.WebGLRenderTarget(1,1,{type: THREE.FloatType});
		}else{
			this._target = new THREE.WebGLRenderTarget();
			this.target = new THREE.WebGLRenderTarget();
		}
		this.isTexture = false;
	}
	dispose(){
		this._target.dispose()
		this.target.dispose()
	}
	setSize(renderer, w, h){
		this._target.setSize(w, h);
		this.target.setSize(w, h);
		renderer.setRenderTarget(this._target);
		renderer.clear();
		renderer.setRenderTarget(this.target);
		renderer.clear();
		renderer.setRenderTarget(null);
	}
	renderTexture(renderer, material, scene, camera){
		let tmp = this._target;
		this._target = this.target;
		this.target = tmp;
		material.uniforms.buffer.value = this._target.texture;
		renderer.setRenderTarget(this.target);
		renderer.render(scene, camera);
		this.isTexture = true;
		renderer.setRenderTarget(null);
	}
}
export default RenderBuffer;
export {RenderBuffer, useTextureToTarget};
